
/** Localized config for edit-account form file validation (max sizes in bytes, allowed_mime_types keyed by extension or mime). */
interface EditMyAccountFileLocalize {
    max_allowed_file_size: number;
    max_allowed_total_file_size: number;
    allowed_mime_types: { [key: string]: string };
}
declare var edit_my_account_localize: EditMyAccountFileLocalize | undefined;

class VM_MyAccountHandler {
    private static edit_my_account_form_selector: string = 'form.edit-account';
    constructor() {

    }

    get_value = ( form_id:string, input_id:string ) => {
        var value:any = jQuery( `${form_id} ${input_id}` ).val();
        return value;
    }

    /** Get file extension from filename (lowercase). */
    private static getFileExtension(filename: string): string {
        return filename.split('.').pop()?.toLowerCase() || '';
    }

    /** Format byte count for display. */
    private static formatFileSize(bytes: number): string {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    }

    /**
     * Validate all file inputs under form.edit-account: single file size and total size.
     * Similar to validateFiles in page-register but for the single edit-account form.
     */
    validateEditAccountFiles = async (): Promise<{ success: boolean; message: string; file_error_messages: { [key: string]: string[] } }> => {
        const form = jQuery(VM_MyAccountHandler.edit_my_account_form_selector);
        if (form.length === 0 || typeof edit_my_account_localize === 'undefined') {
            return { success: true, message: '', file_error_messages: {} };
        }
        const maxSingle = edit_my_account_localize.max_allowed_file_size;
        const maxTotal = edit_my_account_localize.max_allowed_total_file_size;
        const allowedMimeKeys = Object.keys(edit_my_account_localize.allowed_mime_types);

        let totalSize = 0;
        let hasErrors = false;
        const file_error_messages: { [key: string]: string[] } = {};

        form.find('input[type="file"]').each((_index: number, el: HTMLElement) => {
            const inputEl = el as HTMLInputElement;
            const $input = jQuery(inputEl);
            const fieldName = inputEl.name || inputEl.id || ('file_' + _index);

            $input.removeClass('rwmb-error');
            $input.attr('aria-invalid', 'false');
            $input.parent().find('p.rwmb-error').remove();
            if (!file_error_messages[fieldName]) {
                file_error_messages[fieldName] = [];
            }

            if (inputEl.files instanceof FileList && inputEl.files.length > 0) {
                for (let i = 0; i < inputEl.files.length; i++) {
                    const file = inputEl.files[i];
                    const fileExtension = VM_MyAccountHandler.getFileExtension(file.name);
                    const fileErrors: string[] = [];

                    const isAllowedType = allowedMimeKeys.some((allowedType: string) => {
                        if (allowedType.includes('/')) {
                            return allowedType.includes(fileExtension);
                        }
                        return allowedType.toLowerCase().includes(fileExtension);
                    });
                    if (!isAllowedType) {
                        fileErrors.push(`File "${file.name}" has an unsupported extension. Allowed: ${allowedMimeKeys.join(', ').replace(/\|/g, ', ')}`);
                    }
                    if (file.size > maxSingle) {
                        fileErrors.push(`File "${file.name}" is too large (${VM_MyAccountHandler.formatFileSize(file.size)}). Maximum allowed: ${VM_MyAccountHandler.formatFileSize(maxSingle)}`);
                    }
                    totalSize += file.size;
                    if (fileErrors.length > 0) {
                        hasErrors = true;
                        $input.addClass('rwmb-error');
                        $input.attr('aria-invalid', 'true');
                        fileErrors.forEach((err) => {
                            // the .rwmb-error message is cleared by the plugin, so we need to add it after a short delay.
                            setTimeout(() => {
                                $input.parent().append(`<p class="rwmb-error">${err}</p>`);
                            });
                            file_error_messages[fieldName].push(err);
                        }, 200);
                    }
                }
            }
        });

        let top_error_message = '';
        if (!hasErrors && totalSize > maxTotal) {
            hasErrors = true;
            top_error_message = `Total file size (${VM_MyAccountHandler.formatFileSize(totalSize)}) exceeds the limit of ${VM_MyAccountHandler.formatFileSize(maxTotal)}`;
        }
        return {
            success: !hasErrors,
            message: top_error_message,
            file_error_messages: file_error_messages
        };
    };

    init = () => {
        console.log( "initializing my account" );

        // Edit-account form: validate file inputs (single and total size) before submit
        const $editMyAccountForm = jQuery(VM_MyAccountHandler.edit_my_account_form_selector);
        if ($editMyAccountForm.length > 0 && $editMyAccountForm.find('input[type="file"]').length > 0 && typeof edit_my_account_localize !== 'undefined') {
            $editMyAccountForm.on('submit', async (e: JQuery.TriggeredEvent) => {
                const validation = await this.validateEditAccountFiles();
                if (!validation.success) {
                    e.preventDefault();
                    jQuery('#rwmb-validation-message').remove();
                    if (validation.message.length > 0) {
                        $editMyAccountForm.prepend('<p id="rwmb-validation-message" class="rwmb-error">' + validation.message + '</p>');
                    }
                }
            });
        }

        // Block the edit-account submit when a filled address phone is invalid.
        // VmPhoneInput is provided globally by lms-login.js (validate-if-filled).
        if ($editMyAccountForm.length > 0) {
            $editMyAccountForm.on('submit', (e: JQuery.TriggeredEvent) => {
                const vmPhoneInput = (window as any).VmPhoneInput;
                if (vmPhoneInput?.validate && !vmPhoneInput.validate($editMyAccountForm[0])) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
            });
        }
    }
}

jQuery( document ).ready( function( $:any ) {
    const my_account:VM_MyAccountHandler = new VM_MyAccountHandler();
    my_account.init();
} );
